import { makeStyles } from '@mui/styles';
const tooltipStyles = makeStyles(() => ({
    tooltipIcon: {
        fontSize: 20,
    },
    tooltipIconButton: {
        paddingLeft: 4,
    },
    tooltipContent: {
        whiteSpace: 'pre-wrap',
    },
}), { name: 'Common_Tooltip' });
export default tooltipStyles;
//# sourceMappingURL=tooltip.styles.js.map